import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Header from 'apps/components/header/header';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { StoryCard } from 'legacyComponents/cards/types/story';

import { DiscoverStoriesManager } from 'apps/home/discover/stories/appManager';
import { ContentIntro } from 'apps/components/contentIntro';
import { conf } from 'apps/home/discover/config.yaml';

@withNamespaces()
@inject('routerStore')
@observer
export class DiscoverStories extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new DiscoverStoriesManager(null, this.props);
  }

  render() {
    const { t } = this.props;
    const featuredStoriesConnection = this.appManager.featuredStoriesConn;
    const featuredStories = featuredStoriesConnection.arrayApp;

    const storiesConnection = this.appManager.storiesConn;
    const stories = storiesConnection.arrayApp;

    return (
      <>
        <Header />
        <ContentIntro
          title={conf.stories.title}
          description={conf.stories.description}
          tag='Stories'
          createButtonText='Share your Story'
          createButtonLink='home.newStory'
          variant='primary'
          isGrid
          hideIfSignedIn
        />
        <MainWrapper marginTop='2em'>
          {featuredStoriesConnection.loadingMore ||
          featuredStories.length > 0 ? (
            <CardSection
              invisible={this.appManager.loading}
              title={t('Featured Stories')}
              subTitle=' '
              isOwnProfile={false}
              ownerName=''
              cardApp={featuredStories}
              CardComponent={StoryCard}
              noDataCardType='story'
              gridColumns={2}
              first
            />
          ) : null}
          <CardSection
            invisible={this.appManager.loading}
            title={t('All Stories')}
            subTitle=' '
            isOwnProfile={false}
            ownerName=''
            cardApp={stories}
            CardComponent={StoryCard}
            noDataCardType='story'
            gridColumns={2}
            last
          />
        </MainWrapper>
      </>
    );
  }
}

DiscoverStories.propTypes = {
  t: PropTypes.func,
};
